import { Formik } from 'formik'
import { CSSProperties, FC, useContext, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { CheckedBtn } from '../Answers/CheckedBtn/CheckedBtn'
import { Bonuses } from '../Bonuses/Bonuses'
import { Desktop } from '../Container/Desktop'
import { Mobile } from '../Container/Mobile'
import { LayoutContactForm } from '../LayoutContactForm/LayoutContactForm'
import { LineProgress } from '../Progress/LineProgress/LineProgress'
import {
    BoxBonuse,
    BoxSocial,
    ButtonBox,
    CheckedBox,
    FormBox,
    IconBox,
    IconSocial,
    InputContact,
    ItemSocial,
    TextSocial,
    Title,
    TitleBox,
    TitleSocial,
    Wraper,
    StyledPhoneInput,
} from './ContactFormPage.styled'

import { Button } from '../Button/Button'
import { getStyleFromTextConfig } from '../../utils/style'
import { ArticleContent } from '../ArticleContent/ArticleContent'
import { Discount } from '../Discount/Discount'
import { DiscountProgress } from '../DiscountProgress/DiscountProgress'
import { QuizContext } from '../../providers/QuizProvider/QuizContext'
import { useDesktop } from '../../hooks/useDesktop'
import { getProgressDiscount } from '../../utils/progressDiscount'
import { useTranslation } from '../../hooks/useTranslation'
import { Scrollbars } from 'rc-scrollbars'
import { TextLabel } from '../TextLabel/TextLabel'

import 'react-phone-input-2/lib/material.css'

import { sendData } from './helpers/functions'

import { icons } from './helpers/icons'
import { useGetCodeCountryUser } from './helpers/useGetCodeCountryUser'

type Props = {
    formFields?: any[]
    additions: any[]
    onNext?: (data: unknown) => void
}

type DataServer = {
    type: number
    utm?: UtmType
    data?: any
}

type UtmType = {
    [name: string]: string
}

export const ContactFormPage: FC<Props> = ({
    //button_style,
    formFields,
    additions,
    onNext,
}) => {
    const { t } = useTranslation()
    const containerRef = useRef<HTMLDivElement>(null)
    const [height, setHeight] = useState(0)
    const isDesktop = useDesktop()

    useLayoutEffect(() => {
        setHeight((containerRef.current?.getBoundingClientRect().height ?? 0) - (isDesktop ? 0 : 30))
    }, [isDesktop])

    const context = useContext(QuizContext)
    const {
        // form_design_type,
        form_title,
        form_title_config,
        // form_description,
        // form_description_config,
        messengers,
        messengers_config,
        privacy_policy,
        privacy_policy_link,
        currency,
    } = context
    const addition_position_display = context.addition_position_display ?? 1
    const formRef = useRef<any>()
    const [isMessengers, setIsMessengers] = useState('')

    const countryCode = useGetCodeCountryUser()

    const utm = useRef<UtmType>({})

    useEffect(() => {
        let searchParams: UtmType = {}
        for (let [key, value] of new URLSearchParams(window.location.search).entries() as any) {
            if ((key as string).includes('utm'))
                searchParams = {
                    ...searchParams,
                    [key]: value,
                }
        }

        utm.current = searchParams
    }, [])

    const additionsWithoutConsultant = useMemo(() => additions.filter(({ type }) => type !== 3), [additions])

    const initValues = useMemo(() => {
        return {
            ...formFields?.reduce((acc, { id }) => {
                return { ...acc, [id]: '' }
            }, {}),
            ...icons?.reduce((acc, { typeName }) => {
                return { ...acc, [typeName]: '' }
            }, {}),
        }
    }, [formFields])
    const firstProgress = additions.find(({ config }) => config?.typeDiscount === 2)

    const discountProgressValue = firstProgress
        ? getProgressDiscount(
              firstProgress.config?.discountValue,
              1,
              1,
              firstProgress.config?.unitDiscount,
              currency?.title
          )
        : ''

    const widthCheckbox = isDesktop && additions.length > 0 ? '52%' : '100%'
    let styleBox: CSSProperties = { flex: 1, overflow: 'hidden' }
    if (!isDesktop)
        styleBox = {
            ...styleBox,
            width: 'calc(100% + 40px)',
            marginLeft: '-20px',
        }

    return (
        <LayoutContactForm>
            <Mobile>
                <ArticleContent
                    additions={additions}
                    addition_position_display={addition_position_display}
                    discountProgressValue={discountProgressValue}
                    lockBonus={true}
                />
            </Mobile>
            {addition_position_display === 1 && (
                <Desktop>
                    <ArticleContent
                        additions={additions}
                        addition_position_display={addition_position_display}
                        discountProgressValue={discountProgressValue}
                        lockBonus={true}
                    />
                </Desktop>
            )}

            <Wraper addition_position_display={addition_position_display}>
                <Title style={getStyleFromTextConfig(form_title_config)}>{form_title}</Title>

                {additionsWithoutConsultant.length > 0 && (
                    <Mobile>
                        <BoxBonuse>
                            {additionsWithoutConsultant.map((item) =>
                                item.type === 2 ? (
                                    <Discount key={item.id} addition={item} lockBonus={true} disabledDecor={true} />
                                ) : (
                                    <Bonuses key={item.id} addition={item} lockBonus={true} disabledDecor={true} />
                                )
                            )}
                            {additionsWithoutConsultant.length < 2 && firstProgress && (
                                <DiscountProgress text={t('yourDiscount')} value={discountProgressValue} />
                            )}
                        </BoxBonuse>
                    </Mobile>
                )}

                <div style={styleBox} ref={containerRef}>
                    <Scrollbars autoHeightMax={height} autoHeight={!isDesktop}>
                        <Formik
                            innerRef={formRef}
                            initialValues={
                                initValues
                                //   {
                                //   name: "",
                                //   email: "",
                                //   phone: "",
                                //   other: "",
                                //   contacts: "",
                                // }
                            }
                            onSubmit={(values, { setErrors }) => {
                                const { errors, result, isValid } = sendData({
                                    isMessengers,
                                    values,
                                    formFields,
                                    textTranslte: t('required'),
                                })
                                setErrors(errors)

                                if (onNext && isValid) {
                                    const dataToServer: DataServer = {
                                        type: +!!isMessengers,
                                        data: {},
                                    }

                                    if (Object.keys(utm.current).length) {
                                        dataToServer.utm = utm.current
                                    }

                                    const nameInData: string = isMessengers ? 'social_network' : 'contact_form'

                                    if (Object.keys(result).length) {
                                        dataToServer.data[nameInData] = result
                                    }

                                    onNext(dataToServer)
                                }
                            }}
                        >
                            {({ errors, touched, setFieldValue, values }) => (
                                <FormBox>
                                    <LineProgress
                                        value={98}
                                        showTitle={true}
                                        style={{
                                            width: '100%',
                                            marginBottom: '15px',
                                            marginInline: '0px',
                                        }}
                                    />
                                    {!isMessengers &&
                                        formFields?.map(({ id, title, type_field, required }) => {
                                            if (type_field === 2) {

                                                return (
                                                    <StyledPhoneInput
                                                        country={countryCode}
                                                        key={id}
                                                        value={values[id]}
                                                        onChange={(phone) => setFieldValue(id, phone)}
                                                        specialLabel=""
                                                        inputProps={{
                                                            name: 'phone',
                                                            required: required,
                                                        }}
                                                        enableSearch={true}
                                                        containerStyle={{
                                                            marginBottom: '15px',
                                                            borderColor: errors[id] && touched[id] ? 'red' : '',
                                                        }}
                                                        inputStyle={{ width: '100%' }}
                                                    />
                                                )
                                            }

                                            return (
                                                <InputContact
                                                    key={id}
                                                    type={
                                                        type_field === 3 ? 'email' : type_field === 2 ? 'tel' : 'text'
                                                    }
                                                    name={id}
                                                    required={required}
                                                    placeholder={title}
                                                    className={errors[id] && touched[id] ? 'error' : ''}
                                                />
                                                // {errors[id] && touched[id] ? (
                                                //   <span>{errors[id] as string}</span>
                                                // ) : null}
                                            )
                                        })}
                                    {isMessengers &&
                                        icons
                                            .filter(({ typeName }) => typeName === isMessengers)
                                            .map(({ typeName }) => (
                                                <InputContact
                                                    key={typeName}
                                                    type="text"
                                                    name={typeName}
                                                    placeholder={typeName}
                                                    className={errors[typeName] && touched[typeName] ? 'error' : ''}
                                                />
                                                // {errors[typeName] && touched[typeName] ? (
                                                //   <span>{errors[typeName] as string}</span>
                                                // ) : null}
                                            ))}
                                </FormBox>
                            )}
                        </Formik>
                        {messengers && Object.values(messengers_config ?? {}).some((item) => item) && (
                            <>
                                {formFields?.length ? (
                                    <TitleBox>
                                        <TitleSocial>{t('orUseToLogin')}</TitleSocial>
                                    </TitleBox>
                                ) : null}

                                <BoxSocial>
                                    {icons
                                        .filter(
                                            ({ typeName }) =>
                                                typeName === 'contacts' || (messengers_config ?? {})[typeName]
                                        )
                                        .map((icon) => (
                                            <ItemSocial
                                                key={icon.typeName}
                                                onClick={() =>
                                                    setIsMessengers(icon.typeName !== 'contacts' ? icon.typeName : '')
                                                }
                                            >
                                                <IconBox>
                                                    <IconSocial
                                                        src={icon.src}
                                                        width={15}
                                                        height={15}
                                                        title={icon.title}
                                                    />
                                                </IconBox>
                                                <TextSocial>{icon.title}</TextSocial>
                                            </ItemSocial>
                                        ))}
                                </BoxSocial>
                            </>
                        )}

                        {privacy_policy && (
                            <CheckedBox>
                                <CheckedBtn
                                    name="agreement"
                                    text={t('privacyPolicy')}
                                    isChecked={true}
                                    onChange={() => {
                                        window.open(privacy_policy_link, '_blank', 'noopener')
                                    }}
                                    style={{ width: `${widthCheckbox}` }}
                                />
                            </CheckedBox>
                        )}
                    </Scrollbars>
                </div>
                <Mobile>
                    <TextLabel style={{ textAlign: "left", padding: "5px 0px"}} />
                </Mobile>
                <ButtonBox addition_position_display={addition_position_display}>
                    <Button
                        /* type={button_style} */ title={t('continueBtn')}
                        isHideArrow={false}
                        onNext={() => {
                            formRef.current?.handleSubmit()
                            //
                        }}
                    />
                </ButtonBox>
            </Wraper>

            {addition_position_display === 2 && (
                <Desktop>
                    <ArticleContent
                        additions={additions}
                        addition_position_display={addition_position_display}
                        discountProgressValue={discountProgressValue}
                        lockBonus={true}
                    />
                </Desktop>
            )}
        </LayoutContactForm>
    )
}
